(function($){
  $(function(){

    $('.sidenav').sidenav();

  }); // end of document ready
})(jQuery); // end of jQuery name space



// WEBPACK FOOTER //
// ./src/assets/js/init.js